module.exports = __webpack_public_path__ + "static/media/wireframer.9eccd1c6.png";